import { MeasurementControlsSubmenu } from 'features/kestrelViewer/ui/tools/measurementControls/MeasurementControlsSubmenu'
import { PhotoReel } from 'features/kestrelViewer/ui/tools/photoreel'
import { ViewControlsSubmenu } from 'features/kestrelViewer/ui/tools/viewControls/ViewControlsSubmenu'
import { VisibilityTogglesSubmenu } from 'features/kestrelViewer/ui/tools/visibilityToggles/VisibilityTogglesSubmenu'
import React from 'react'

export const ViewToggles: React.FC = () => {
  return (
    <div>
      <ViewControlsSubmenu />
      <VisibilityTogglesSubmenu />
      <MeasurementControlsSubmenu />
      <PhotoReel />
    </div>
  )
}
